import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { M_Table } from 'src/M_Components'

export const Company = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate  }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const NewRoute = (url, label) => {
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const removeContextItems = ['Print']

    return (
        <M_Table entityName={'company'} 
        rolePermissions={roles} 
        tablesOrder={tablesOrder} 
        onTablesOrderUpdate={onTablesOrderUpdate}
        pageUrl={'Company'}
        removeContextItems={removeContextItems} />
    )
}
